import React, { memo, useRef, useState } from "react";
import { Button, Col } from "reactstrap";
import { BiSolidUpArrow } from "react-icons/bi";

import InputTextComponent from "../../../components/forms/InputTextComponent";
import DatePicker from "../../../components/forms/DatePicker";
const translator = require("../../../utils/translator/translator");

const MoreDetailsBox = ({ emailAddress, dateOfBirth, onChange }) => {
     const [toggleMoreDetails, setToggleMoreDetails] = useState(false);

     const handleOnClickMoreDetails = () => setToggleMoreDetails((prev) => !prev);

     return (
          <div className="d-flex flex-column">
               <Button
                    className="d-flex gap-2 btn-action border-0 text-start align-items-center"
                    style={{ fontSize: "1rem" }}
                    onClick={handleOnClickMoreDetails}
               >
                    <BiSolidUpArrow style={{ width: "1rem", transform: toggleMoreDetails ? "rotate(180deg)" : "rotate(90deg)" }} />{" "}
                    {translator.getLabel("more_details")}
               </Button>
               {toggleMoreDetails && (
                    <div className="d-flex flex-row gap-3">
                         <Col>
                              <CustomerEmailField value={emailAddress} onChange={onChange} />
                         </Col>
                         <Col>
                              <CustomerDOBField value={dateOfBirth} onChange={onChange} />
                         </Col>
                    </div>
               )}
          </div>
     );
};

export default memo(MoreDetailsBox);

const CustomerEmailField = memo(({ value, required = false, onChange }) => {
     return (
          <InputTextComponent
               autoComplete="off"
               name="emailAddress"
               required={required}
               type="text"
               placeholder={translator.getLabel("email")}
               value={value}
               onValueChange={onChange}
               inputTextType="text"
          />
     );
});

const CustomerDOBField = memo(({ value, required = false, onChange }) => {
     const [isOpen, setIsOpen] = useState(false);

     const datePickerRef = useRef();
     return (
          <>
               <div
                    ref={datePickerRef}
                    onClick={() => {
                         setIsOpen((prev) => !prev);
                    }}
               >
                    <InputTextComponent
                         autoComplete="off"
                         name="dateOfBirth"
                         required={required}
                         type="date"
                         placeholder={translator.getLabel("date_of_birth")}
                         value={value}
                         containerStyle={{ pointerEvents: "none" }}
                    />
               </div>
               <DatePicker
                    value={value}
                    innerRef={datePickerRef}
                    isOpen={isOpen}
                    placement="right"
                    onChange={(date) => {
                         onChange(date ? date : "", "dateOfBirth");
                         setIsOpen(false);
                    }}
                    onOutSideClick={() => setIsOpen(false)}
               />
          </>
     );
});
